export const state = () => ({
  search: '',
  loading: false,
  clean: true,
  error: true,
  isRetroactive: false,
  selectedDay: null,
  selectedSalesman: null,
  selectedCoordinator: null,
  detailedAllowance: null,
  selectedItems: [],
  clients: [],
  salesmen: [],
  coordinators: [],
  otherAllowances: [],
  pendingApprovalRetroactiveAllowances: [],
})

export const mutations = {
  setState: (state, value) => Object.assign(state, value),
  setClientVisitFrequency: (state, payload) => {
    state.selectedItems = state.selectedItems.map(item => {
      if (item.client.code !== payload.clientCode) return item
      return {
        ...item,
        client: {
          ...item.client,
          visitFrequency: payload.visitFrequency,
        },
      }
    })
  },
}

export const actions = {
  async fetch({ commit, state, rootState }) {
    const { clean } = state
    if (clean) commit('setState', { loading: true })
    try {
      const { data } = await this.$axios.get(
        '/v3/app/allowance/client-allowances/forms'
      )
      const tokenize = (v, id) => ({ ...v, id })
      const user = {
        employeeCode: rootState.auth.user.employeeCode,
        name: rootState.auth.user.name,
        teleSales: rootState.auth.user.teleSales,
        ancestors: rootState.auth.user.ancestors,
        jobTitle: rootState.auth.user.jobTitle,
      }
      if (user.jobTitle !== 'Vendedor') data.salesmen?.unshift(user)
      commit('setState', {
        salesmen: data.salesmen.map?.(tokenize) ?? [],
        coordinators: data.coordinators.map?.(tokenize) ?? [],
        clients: data.clients.map?.(tokenize) ?? [],
        otherAllowances: data.otherAllowances.map?.(tokenize) ?? [],
        clean: false,
        loading: false,
        error: false,
        selectedItems: [],
      })
    } catch (e) {
      console.log(e)
      commit('setState', { loading: false, error: true })
    }
  },
  async fetchPendingApprovalRetroactiveAllowances(
    { commit, state },
    { forceUpdate } = { forceUpdate: false }
  ) {
    if (state.pendingApprovalRetroactiveAllowances.length > 0 && !forceUpdate)
      return
    try {
      commit('setState', { loading: true })
      const { data } = await this.$axios.get(
        '/v3/app/retroactiveallowance/pending-approval'
      )
      const tokenize = (v, id) => ({ ...v, id })
      commit('setState', {
        pendingApprovalRetroactiveAllowances: data.map?.(tokenize) ?? [],
        loading: false,
      })
    } catch (error) {
      console.error(error)
      commit('setState', { loading: false })
    }
  },
}
